export default {
    _LEARNING_WINDOW_NAME: '3dslearningWindow',
    _POPUP_TOP_OFFSET: 50,
    _POPUP_OFFSET: 200,
    _POPUP_MIN_SIZE: 400 // mini size of popup
}